import '../css/reset.css';
import '../css/common.css';
import '../css/public-test-total-care.css';

import 'lazysizes';

// import ClipBoard from 'clipboard';
import {
  OLD_API_URL, requestPOST, getClientID, getInfoOfDeviceOS,
} from './common-es6';

// const snsShareKakao = document.getElementsByClassName('sns-kakao')[0];
// const snsShareFacebook = document.getElementsByClassName('sns-facebook')[0];
// const snsShareTwitter = document.getElementsByClassName('sns-twitter')[0];
// const snsShareLink = document.getElementsByClassName('sns-link')[0];
//
// const shareMainLink = `${window.location.origin}/service/test/`;
const deviceOS = getInfoOfDeviceOS();

const bgTop1 = document.getElementById('bgTop1');
const bgTop2 = document.getElementById('bgTop2');
const fixedProgressBarStep1 = document.getElementById('fixedProgressBarStep1');
const fixedProgressBarStep2 = document.getElementById('fixedProgressBarStep2');

const programTypeQuestion = document.getElementById('program-type-questions');
const questionScoreStep1 = programTypeQuestion ? programTypeQuestion.getElementsByTagName('tr') : [];

// const sendLink = () => {
//   Kakao.Link.sendDefault({
//     objectType: 'feed',
//     content: {
//       title: '지금 나의 심리상태와 성격이 궁금하다면?',
//       description: '전문적인 자기분석 검사로 나의 진짜 심리상태와 성격 알아보기!',
//       imageUrl: 'https://assets.trost.co.kr/images/service/tests/share_sns_kakao.png',
//       link: {
//         mobileWebUrl: shareMainLink,
//         webUrl: shareMainLink,
//       },
//       imageWidth: 800,
//       imageHeight: 800,
//     },
//     social: {
//       likeCount: 286,
//       commentCount: 45,
//       sharedCount: 845,
//     },
//     buttons: [
//       {
//         title: '지금 자기분석 테스트 시작',
//         link: {
//           mobileWebUrl: shareMainLink,
//           webUrl: shareMainLink,
//         },
//       },
//     ],
//   });
// };

const setControlPage = () => {
  window.scroll(0, 0);
};

// 평가 질문
const realQuestions = {
  depression: [
    ['슬프거나 침울하게 느껴진다', [0, 1, 2, 3]],
    ['미래에 대한 희망이 없게 느껴진다', [0, 1, 2, 3]],
    ['나는 가치 없는 사람인 것 같다', [0, 1, 2, 3]],
    ['다른 사람과 비교했을 때 나는 열등하거나 못난 존재이다', [0, 1, 2, 3]],
    ['나에 대한 불평과 자책을 하곤 한다', [0, 1, 2, 3]],
    ['어떤 결정을 내리기가 어렵다', [0, 1, 2, 3]],
    ['종종 화내거나 분노를 표출한다', [0, 1, 2, 3]],
    ['나의 직업, 취미, 가족 또는 친구에게 흥미를 잃었다', [0, 1, 2, 3]],
    ['스스로 일을 시작하는 것이 힘겹다', [0, 1, 2, 3]],
    ['내가 늙어 보이거나 매력이 없다, 초라하다고 느낀다', [0, 1, 2, 3]],
    ['식욕이 없거나 강박적으로 과식을 하거나 술을 마신다', [0, 1, 2, 3]],
    ['단잠을 이루기가 어렵고 지나치게 피곤을 느끼거나 잠을 너무 많이 잔다', [0, 1, 2, 3]],
    ['성생활에 대한 흥미를 잃었다', [0, 1, 2, 3]],
    ['건강에 대한 걱정을 지나치게 한다', [0, 1, 2, 3]],
    ['인생은 살 가치가 없다거나 죽는 것이 더 낫다고 생각한다', [0, 1, 2, 3]],
  ],
  anxiety: [
    ['침착하지 못하다', [0, 1, 2, 3]],
    ['나쁜 일이 일어날 것 같은 생각이 든다', [0, 1, 2, 3]],
    ['자주 손이나 다리가 떨린다', [0, 1, 2, 3]],
    ['가끔씩 심장이 두근거리고 빨리 뛴다', [0, 1, 2, 3]],
    ['흥분된 느낌을 받는다', [0, 1, 2, 3]],
    ['어지러움이나 현기증을 느낀다', [0, 1, 2, 3]],
    ['편안하게 쉴 수가 없다', [0, 1, 2, 3]],
    ['자주 겁을 먹고 무서움을 느낀다', [0, 1, 2, 3]],
    ['신경이 예민하다', [0, 1, 2, 3]],
    ['가끔씩 숨이 막히고 질식할 것 같다', [0, 1, 2, 3]],
    ['안절부절 못하다', [0, 1, 2, 3]],
    ['미치거나 죽을 것 같은 두려움을 느낀다', [0, 1, 2, 3]],
    ['자주 소화가 잘 안 되고 늘 뱃속이 불편하다', [0, 1, 2, 3]],
    ['자주 얼굴이 붉어지곤 한다', [0, 1, 2, 3]],
    ['근육이 긴장되어 뻣뻣해지고 저린다', [0, 1, 2, 3]],
  ],
  // trauma: [
  //   ['그 일에 대해 생각하고 싶지도 않을 때 불쑥 생각나거나 머릿 속에 그려진다', [0, 1, 2, 3]],
  //   ['그 일과 관련된 악몽을 꾼다', [0, 1, 2, 3]],
  //   ['그 일이 마치 재현되듯 생생하게 느껴지고 그 때 당시처럼 행동하게 된다', [0, 1, 2, 3]],
  //   ['그 일을 떠올리면 괴로운 감정이 든다.(예:두렵다, 분노가 치밀어 오른다, 슬프다,  죄책감이 느껴진다 등)', [0, 1, 2, 3]],
  //   ['그 일을 떠올리면 신체적 반응이 느껴진다.(예:진땀이 난다, 심장이 뛴다.)', [0, 1, 2, 3]],
  //   ['그 일에 대해서는 생각하거나, 말하지 않으려 하고, 당시의 느낌조차 떠올리지 않으려고 애를 쓴다', [0, 1, 2, 3]],
  //   ['그 일을 생각나게 하는 활동이나 사람들, 장소들을 가급적 피하려 한다', [0, 1, 2, 3]],
  //   ['그 일과 관련된 중요한 기억의 한부분이 도무지 생각나지 않는다', [0, 1, 2, 3]],
  //   ['지금 내 생활에서 중요한 것들에 대해 흥미가 떨어지거나 의욕이 낮아졌다', [0, 1, 2, 3]],
  //   ['주위 사람들과 멀어지거나 단절된 느낌이다', [0, 1, 2, 3]],
  // ],
  negative: [
    ['나는 내가 알고 있는 사람들만큼 행복한 생활을 하고 있다', [3, 2, 1, 0]],
    ['아침에 잠에서 깨어나면서 내가 세상에서 최고라고 느껴본 적이 있다', [3, 2, 1, 0]],
    ['다른 사람들은 모두 쉽게 행운을 잡는 것처럼 느껴진다', [0, 1, 2, 3]],
    ['나에게는 정해진 몫보다 더 많은 불운이 돌아오는 것처럼 생각된다', [0, 1, 2, 3]],
    ['뚜렷한 이유도 없이 불행하다는 생각을 해본 적이 있다', [0, 1, 2, 3]],
    ['희망이 없어 보이는 일을 하고 있다고 느껴본 적이 있다', [0, 1, 2, 3]],
    ['나의 생활이 무의미한 것처럼 느껴지는 때가 많다', [0, 1, 2, 3]],
    ['세상은 근본적으로 불행한 곳이라고 생각한다', [0, 1, 2, 3]],
    ['소음으로 인해 격분할 때가 많다', [0, 1, 2, 3]],
    ['나의 생활이 법에 의해 일그러지고 있다고 생각한다', [0, 1, 2, 3]],
    ['내가 알고 있는 대부분의 사람들처럼 나도 웃으며 생활하고 있다', [0, 1, 2, 3]],
    ['대부분의 사람들처럼 나도 사람들에게 미소를 보낸다', [0, 1, 2, 3]],
    ['뚜렷한 이유도 없이 나른하고 피곤할 때가 많다', [0, 1, 2, 3]],
    ['다른 사람들에 의해 나의 생활이 얼룩져 왔다고 생각한다', [0, 1, 2, 3]],
    ['나의 생활에 나를 걱정시키고 격분시키는 방해물이 있다고 생각한다', [0, 1, 2, 3]],
  ],
  selfesteem: [
    ['나는 내가 목표한 일에서 좋은 결과를 얻을 수 있다', [0, 1, 2, 3]],
    ['나는 경쟁에서 잘 이기는 편이다', [0, 1, 2, 3]],
    ['나는 남들은 하지 못하는 일을 가끔 해낸다', [0, 1, 2, 3]],
    ['나는 하고 싶은 일을 행동으로 잘 옮긴다', [0, 1, 2, 3]],
    ['나는 많은 사람들 앞에서도 할 말은 한다', [0, 1, 2, 3]],
    ['나는 다른 사람들에게 의존하지 않고 나의 일을 스스로 한다', [0, 1, 2, 3]],
    ['나는 주위 사람들로부터 인정받고 있다', [0, 1, 2, 3]],
    ['내가 속한 집단에서 책임과 의무를 다한다', [0, 1, 2, 3]],
    ['나와 가까운 사람들(가족, 친구)은 나를 소중하게 생각한다', [0, 1, 2, 3]],
    ['나는 다른 사람들과 좋은 관계를 유지하고 있다', [0, 1, 2, 3]],
    ['나는 남들을 잘 배려한다', [0, 1, 2, 3]],
    ['나는 내가 속한 집단의 조화를 유지하는 데 기여한다', [0, 1, 2, 3]],
  ],
  relationship: [
    ['나는 나보다 높은 지위에 있는 사람과 대화할 때면 긴장된다', [0, 1, 2, 3]],
    ['나는 다른 사람들과 눈을 마주치기가 힘들다', [0, 1, 2, 3]],
    ['나 자신이나 내 감정에 대해서 말해야 할 때면 긴장된다', [0, 1, 2, 3]],
    ['동료들과 편안하게 어울리는 것이 어렵다', [0, 1, 2, 3]],
    ['내 나이 또래 친구들을 사귀기 쉽다', [3, 2, 1, 0]],
    ['길에서 아는 사람을 만나면 긴장된다', [0, 1, 2, 3]],
    ['여러 사람들과 어울리는 것이 불편하다', [0, 1, 2, 3]],
    ['다른 사람과 단 둘이 있는 상황에서는 긴장된다', [0, 1, 2, 3]],
    ['모임에서 사람들을 만나는 것이 편안하다', [3, 2, 1, 0]],
    ['다른 사람들과 이야기하는 것이 어렵다', [0, 1, 2, 3]],
    ['나는이야깃거리를 쉽게 생각해낸다', [3, 2, 1, 0]],
    ['이상하게 보일까봐 나 자신을 표현하는 것이 걱정된다', [0, 1, 2, 3]],
    ['다른 사람 주장에 반대하기가 어렵다', [0, 1, 2, 3]],
    ['매력적인 이성과 이야기하는 것이 어렵다', [0, 1, 2, 3]],
    ['사회적 상황에서 무엇을 말해야할 지 몰라 걱정하곤 한다', [0, 1, 2, 3]],
    ['잘 알지 못하는 사람들과 어울려야 할 때 불편하다', [0, 1, 2, 3]],
    ['대화 도중 부적절한 말을 할 것 같다', [0, 1, 2, 3]],
    ['여러 사람들과 어울려 이야기할 때 무시당할까봐 걱정하고는 한다', [0, 1, 2, 3]],
    ['여러 사람들과 어울릴 때 긴장한다', [0, 1, 2, 3]],
    ['잘 알지 못하는 사람에게 인사를 해야할 지 망설인다', [0, 1, 2, 3]],
  ],
  groupStress: [
    ['내가 일하는 장소와 환경은 깨끗하고 쾌적하다', [4, 3, 2, 1]],
    ['내 일은 위험하며 사고를 당할 가능성이 있다', [1, 2, 3, 4]],
    ['내 업무는 불편한 자세로 오랫동안 일을 해야 한다', [1, 2, 3, 4]],
    ['나는 일이 많아 항상 시간에 쫓기며 일한다', [1, 2, 3, 4]],
    ['현재 하던 일을 끝내기 전에 다른 일을 하도록 지시 받는다', [1, 2, 3, 4]],
    ['나는 최근 업무량이 현저하게 증가하였다', [1, 2, 3, 4]],
    ['나는 동료나 나의 팀원을 돌보고 책임져야할 부담을 안고 있다', [1, 2, 3, 4]],
    ['내 업무는 장시간 동안 높은 집중력이 요구된다', [1, 2, 3, 4]],
    ['내 업무는 업무 시간 중에 충분한 휴식이 주어진다', [4, 3, 2, 1]],
    ['나는 일이 너무 많아서 직장과 가정에 다 잘하기가 힘들다', [1, 2, 3, 4]],
    ['내 업무는 동시에 여러 가지 일을 해야 한다', [1, 2, 3, 4]],
    ['내 업무는 창의력을 필요로 한다', [4, 3, 2, 1]],
    ['업무관련 사항(업무의 일정, 업무량, 회의시간 등)이 예고 없이 갑작스럽게 정해지거나 바뀐다', [1, 2, 3, 4]],
    ['내 업무를 수행하기 위해서는 높은 수준의 기술이나 지식이 필요하다', [4, 3, 2, 1]],
    ['나의 작업시간이나 업무 수행과정과 관련된 사항은 나에게 결정할 권한이 주어지며 충분한 영향력을 행사할 수 있다', [4, 3, 2, 1]],
    ['나의 업무량과 작업스케줄을 스스로 조절할 수 있다', [4, 3, 2, 1]],
    ['나의 상사는 업무를 완료하는데 도움을 준다', [4, 3, 2, 1]],
    ['나의 동료는 업무를 완료하는데 도움을 준다', [4, 3, 2, 1]],
    ['직장에서 내가 힘들 때 내가 힘들다는 것을 알아주고 이해해 주는 사람이 있다', [4, 3, 2, 1]],
    ['직장생활의 고충을 함께 나눌 동료가 있다', [4, 3, 2, 1]],
    ['지금의 직장을 옮겨도 나에게 적합한 새로운 일을 쉽게 찾을 수 있다', [4, 3, 2, 1]],
    ['현재의 직장을 그만두더라도 현재 수준만큼의 직업 (직장)을 쉽게 구할 수 있다', [4, 3, 2, 1]],
    ['직장사정이 불안하여 미래가 불확실하다', [1, 2, 3, 4]],
    ['나의 직업은 실직하거나 해고당할 염려가 없다', [4, 3, 2, 1]],
    ['앞으로 2년 동안 현재의 내 직업을 잃을 가능성이 있다', [1, 2, 3, 4]],
    ['나의 근무조건이나 상황에 바람직하지 못한 변화(예, 구조조정)가 있었거나 있을 것으로 예상된다', [1, 2, 3, 4]],
    ['우리 직장은 근무평가, 인사제도(승진, 부서배치 등)가 공정하고 합리적이다', [4, 3, 2, 1]],
    ['업무수행에 필요한 인원, 공간, 시설, 장비, 교육 등의 지원이 잘 이루어지고 있다', [4, 3, 2, 1]],
    ['우리 부서와 타 부서간에는 마찰이 없고 업무협조가 잘 이루어진다', [4, 3, 2, 1]],
    ['직원, 관리자, 임원 모두가 목표를 위해 한마음으로 일을 한다', [4, 3, 2, 1]],
    ['일에 대한 나의 생각을 반영할 수 있는 기회와 통로가 있다', [4, 3, 2, 1]],
    ['나의 경력개발과 승진은 무난히 잘 될 것으로 예상한다', [4, 3, 2, 1]],
    ['내 현재 직위는 나의 교육 및 경력에 비추어볼 때 적절하다', [4, 3, 2, 1]],
    ['나의 직업은 내가 평소 기대했던 것에 미치지 못한다', [1, 2, 3, 4]],
    ['나의 모든 노력과 성과를 고려할 때 내 연봉/수입은 적절하다', [4, 3, 2, 1]],
    ['나의 모든 노력과 성과를 고려할 때, 나는 직장에서 제대로 존중과 신임을 받고 있다', [4, 3, 2, 1]],
    ['나는 지금 하는 일에 흥미를 느낀다', [4, 3, 2, 1]],
    ['내 사정이 앞으로 더 좋아질 것을 생각하면 힘든 줄 모르고 일하게 된다', [4, 3, 2, 1]],
    ['나에게는 나의 능력을 개발하고 발휘할 수 있는 기회가 주어진다', [4, 3, 2, 1]],
    ['나는 회식자리가 불편하다', [1, 2, 3, 4]],
    ['나는 기준이나 일관성이 없는 상태로 업무 지시를 받는다', [1, 2, 3, 4]],
    ['조직문화가 권위적이고 수직적이다', [1, 2, 3, 4]],
    ['우리 조직은 남성, 여성이라는 성적인 차이 때문에 불이익을 받고는 한다', [1, 2, 3, 4]],
  ],
};

// 직장 문화 스트레스
// 직무 요구 스트레스
// 직무 자율 스트레스
// 직무 불안정 스트레스
// 조직 체계 스트레스
// 보상 부적절 스트레스
// 관계 갈등 스트레스
// 물리 환경 스트레스

// 진단 점수
const preAnswerPoint = {
  depression: 0,
  anxiety: 0,
  // trauma: 0,
  negative: 0,
  selfesteem: 0,
  relationship: 0,
  groupStress: 0,
};

// 진단 점수
const questionsTitle = {
  depression: '지난 2주간 일상 속에서 느낀 나의 우울함은?',
  anxiety: '지난 2주간 일상 속에서 느낀 나의 불안함은?',
  // trauma: '나의 일상 속 심리적 트라우마는 어느 정도일까요?',
  negative: '지난 2주간 일상 속에서 느낀 나의 사고방식은?',
  selfesteem: '지난 2주간 일상 속에서 느낀 나의 자존감은?',
  relationship: '지난 2주간 일상 속에서 느낀 나의 대인관계는?',
  groupStress: '당신의 회사 생활은 어떠한가요?',
};

// 진단 점수 순위
const preQuestionPointSorted = [
  'depression',
  'anxiety',
  // 'trauma',
  'negative',
  'selfesteem',
  'relationship',
  'groupStress',
];
let sortTestList = [];
let targetData = '';
let totalQuestionCount = 0;
let progressQuestionCount = 0;
let clickedAnswerData = 0;

// 전체 결과 = 진단 점수 / 실제 검사 점수 / 진행 여부
const testOverAllResult = {
  depression: [0, 0, false],
  anxiety: [0, 0, false],
  // trauma: [0, 0, false],
  negative: [0, 0, false],
  selfesteem: [0, 0, false],
  relationship: [0, 0, false],
  groupStress: [0, 0, false],
};

const testAllAnswers = {
  depression: [],
  anxiety: [],
  // trauma: [],
  negative: [],
  selfesteem: [],
  relationship: [],
  groupStress: [],
};

// 유저 데이터
let userData = {
  name: '',
  phoneNumber: '',
  email: '',
};

const initProgressBar = (clickedCount = 0, totalCount = 0) => {
  if ((!clickedCount) || (!totalCount)) {
    document.getElementsByClassName('program-progress-bar-percent')[0].innerHTML = '0%';
    document.getElementsByClassName('program-progress-bar-percent')[1].innerHTML = '0%';
    document.getElementsByClassName('program-progress-bar-fill')[0].style.background = '';
    document.getElementsByClassName('program-progress-bar-fill')[1].style.background = '';
    document.getElementsByClassName('program-progress-bar-fill')[0].style.width = 0;
    document.getElementsByClassName('program-progress-bar-fill')[1].style.width = 0;

    return false;
  }

  const clickedCountPercent = Math.round((clickedCount / totalCount) * 100);
  let progressBarBGColor = '';

  if (clickedCountPercent < 31) {
    progressBarBGColor = 'FF5A2E';
  } else if (clickedCountPercent < 61) {
    progressBarBGColor = 'FEA853';
  } else {
    progressBarBGColor = '00BC78';
  }

  document.getElementsByClassName('program-progress-bar-percent')[0].innerHTML = `${clickedCountPercent}%`;
  document.getElementsByClassName('program-progress-bar-percent')[1].innerHTML = `${clickedCountPercent}%`;
  document.getElementsByClassName('program-progress-bar-fill')[0].style.backgroundColor = `#${progressBarBGColor}`;
  document.getElementsByClassName('program-progress-bar-fill')[1].style.backgroundColor = `#${progressBarBGColor}`;
  document.getElementsByClassName('program-progress-bar-fill')[0].style.width = `${clickedCountPercent}%`;
  document.getElementsByClassName('program-progress-bar-fill')[1].style.width = `${clickedCountPercent}%`;

  if (clickedCountPercent >= 100) {
    document.getElementsByClassName('program-progress-bar-fill')[0].style.borderRadius = '10px';
    document.getElementsByClassName('program-progress-bar-fill')[1].style.borderRadius = '10px';
  }
};

const setProgramQuestionsEl = (targetTest) => {
  const programQuestionsList = document.getElementById('program-questions-list');
  const testClicked = localStorage[targetTest] ? JSON.parse(localStorage[targetTest]) : [];
  const clickedArrayStep2 = [];

  targetData = targetTest;

  window.scroll(0, 0);
  document.getElementById('program-questions-sub-title').innerHTML = questionsTitle[targetTest];

  let programQuestionsEl = '';

  for (let i = 0; i < Object.keys(realQuestions[targetTest]).length; i++) {
    programQuestionsEl = `${programQuestionsEl}<h4>Q. ${realQuestions[targetTest][i][0]}</h4>`
        + '<table data-role="table" class="program-psychological-answer-table">'
        + '<tr>'
        + `<td data-value="${realQuestions[targetTest][i][1][0]}">1</td>`
        + '<td class="not_choice"></td>'
        + `<td data-value="${realQuestions[targetTest][i][1][1]}">2</td>`
        + '<td class="not_choice"></td>'
        + `<td data-value="${realQuestions[targetTest][i][1][2]}">3</td>`
        + '<td class="not_choice"></td>'
        + `<td data-value="${realQuestions[targetTest][i][1][3]}">4</td>`
        + '</tr>'
        + '</table>'
        + '<div class="question-point-guide">'
        + '<span class="low">전혀<br class="display-only-mobile"/> 아니다</span>'
        + '<span class="high">매우<br class="display-only-mobile"/> 그렇다</span>'
        + '</div>'
        + '<hr/>';
  }

  document.getElementById('program-questions-list').innerHTML = `${programQuestionsEl}<button class="program-button program-prev-start actived">이전</button><button class="program-button program-next-start">다음</button>`;

  const programQuestionsPoint = document.getElementById('program-questions-list');
  const questionScoreStep2 = programQuestionsPoint ? programQuestionsPoint.getElementsByTagName('tr') : [];

  for (let i = 0; i < questionScoreStep2.length; i += 1) {
    questionScoreStep2[i].addEventListener('click', () => {
      clickedArrayStep2[i] = 1;
      programQuestionsPoint.getElementsByTagName('h4')[i].classList.remove('is-orange');

      if (!questionScoreStep2[i + 1]) {
        const lastScorll = 300;
        window.scrollBy({ top: lastScorll, left: 0, behavior: 'smooth' });
        return false;
      }

      if (i === 0) {
        const elementPosition = document.getElementById('program-questions').getBoundingClientRect().top - 80;

        window.scrollTo({
          top: elementPosition,
          behavior: 'smooth',
        });

        return false;
      }

      const moveScrollTop = questionScoreStep2[i + 1].getBoundingClientRect().y - questionScoreStep2[i].getBoundingClientRect().y;
      window.scrollBy({ top: moveScrollTop, left: 0, behavior: 'smooth' });
    });
  }

  // 프로그램 Clicked 이벤트 설정
  const questionEl = document.getElementsByClassName('program-psychological-answer-table');
  const questionLength = document.getElementsByClassName('program-psychological-answer-table').length;

  clickedArrayStep2.length = questionLength;
  totalQuestionCount = 0;
  // 프로그래스바 계산을 위한 현재까지 진행한 문항 수와 전체 문항 수 계산 로직
  for (let i = 0; i < sortTestList.length; i += 1) {
    totalQuestionCount += realQuestions[sortTestList[i]].length;

    if (testOverAllResult[sortTestList[i]][2] === true) {
      progressQuestionCount += realQuestions[sortTestList[i]].length;
    }
  }

  if (testClicked.length) {
    for (let i = 0; i < programQuestionsList.getElementsByTagName('table').length; i += 1) {
      const getTdElement = programQuestionsList.getElementsByTagName('table')[i].getElementsByTagName('td');
      for (let j = 0; j < getTdElement.length; j += 1) {
        if (getTdElement[j].dataset.value && getTdElement[j].dataset.value == testClicked[i]) {
          getTdElement[j].classList.add('clicked');
          break;
        }
      }
    }

    if (document.getElementsByClassName('program-questions-point')[0].getElementsByClassName('clicked').length === Object.keys(realQuestions[targetTest]).length) {
      document.getElementsByClassName('program-next-start')[0].classList.add('actived');
    }
  }

  for (let i = 0; i < questionLength; i += 1) {
    const questionAnswerEl = questionEl[i].getElementsByTagName('td');
    const questionAnswerLength = questionEl[i].getElementsByTagName('td').length;

    for (let j = 0; j < questionAnswerLength; j += 1) {
      if (!questionAnswerEl[j].classList.contains('not_choice')) {
        questionAnswerEl[j].addEventListener('click', () => {
          testAllAnswers[targetTest][i] = questionAnswerEl[j].getAttribute('data-value');

          for (let k = 0; k < questionAnswerLength; k += 1) {
            if (questionAnswerEl[k].classList.contains('clicked')) {
              clickedAnswerData -= 1;
            }

            questionAnswerEl[k].classList.remove('clicked');
          }

          if (!questionAnswerEl[j].classList.contains('clicked')) {
            questionAnswerEl[j].classList.add('clicked');
            clickedAnswerData += 1;
          }

          initProgressBar(clickedAnswerData, totalQuestionCount);

          if (document.getElementsByClassName('program-questions-point')[0].getElementsByClassName('clicked').length === Object.keys(realQuestions[targetTest]).length) {
            document.getElementsByClassName('program-next-start')[0].classList.add('actived');
          }
        });
      }
    }
  }

  // '다음' 버튼 선택 시
  document.getElementsByClassName('program-next-start')[0].addEventListener('click', () => {
    bgTop1.style.marginBottom = '0';

    if (document.getElementsByClassName('program-next-start')[0].classList.contains('actived')) {
      const targetTestChecked = [];
      let testPoint = 0;
      let clickedCount = 0;

      for (let i = 0; i < programQuestionsList.getElementsByTagName('table').length; i += 1) {
        const clickedNode = programQuestionsList.getElementsByTagName('table')[i].getElementsByClassName('clicked')[0];
        if (programQuestionsList.getElementsByTagName('table')[i].getElementsByClassName('clicked')[0]) {
          targetTestChecked.push(clickedNode.dataset.value);
        } else {
          targetTestChecked.push(-1);
        }
      }

      localStorage.setItem(targetTest, JSON.stringify(targetTestChecked));

      for (let i = 0; i < questionLength; i++) {
        const questionAnswerEl = questionEl[i].getElementsByTagName('td');
        const questionAnswerLength = questionEl[i].getElementsByTagName('td').length;

        for (let j = 0; j < questionAnswerLength; j++) {
          if (questionAnswerEl[j].classList.contains('clicked')) {
            clickedCount += 1;
            testPoint += questionAnswerEl[j].getAttribute('data-value') * 1;
          }
        }
      }

      if (clickedCount === realQuestions[targetTest].length) {
        // 전체 점수 현황 데이터 업데이트
        testOverAllResult[targetTest] = [
          preAnswerPoint[targetTest],
          testPoint,
          true,
        ];

        // 다음으로 진행이 되어야 하는 검사 확인 후 실행 - preQuestionPointSorted 내부 데이터 확인
        const hasTarget = sortTestList.indexOf(targetTest);

        if (hasTarget !== -1 && sortTestList[hasTarget + 1]) {
          return setProgramQuestionsEl(sortTestList[hasTarget + 1]);
        }

        /**
         * 추가 입력 사항 입력
         * 결과 데이터 Api 전송
         * 보고서 페이지 연결
         */
        document.getElementsByClassName('page-program-questions')[0].style.display = 'none';
        document.getElementById('program-questions').style.display = 'none';

        document.getElementsByClassName('page-program-questions-more')[0].style.display = 'block';
        document.getElementById('program-questions-more').style.display = 'block';
        setControlPage();

        let name = '';
        let email = '';
        let phoneNumber = '';

        document.getElementsByClassName('name')[0].addEventListener('change', () => {
          if (
            document.getElementsByClassName('name')[0].value
              && document.getElementsByClassName('email')[0].value
              && document.getElementsByClassName('phoneNumber')[0].value
              && document.getElementsByClassName('data_approved')[0].checked
          ) {
            document.getElementById('program-psychological-finish').classList.add('actived');
          }
        });

        document.getElementsByClassName('email')[0].addEventListener('change', () => {
          if (
            document.getElementsByClassName('name')[0].value
              && document.getElementsByClassName('email')[0].value
              && document.getElementsByClassName('phoneNumber')[0].value
              && document.getElementsByClassName('data_approved')[0].checked
          ) {
            document.getElementById('program-psychological-finish').classList.add('actived');
          }
        });

        document.getElementsByClassName('phoneNumber')[0].addEventListener('change', () => {
          if (
            document.getElementsByClassName('name')[0].value
              && document.getElementsByClassName('email')[0].value
              && document.getElementsByClassName('phoneNumber')[0].value
              && document.getElementsByClassName('data_approved')[0].checked
          ) {
            document.getElementById('program-psychological-finish').classList.add('actived');
          }
        });

        document.getElementsByClassName('data_approved')[0].addEventListener('change', () => {
          if (
            document.getElementsByClassName('name')[0].value
              && document.getElementsByClassName('email')[0].value
              && document.getElementsByClassName('phoneNumber')[0].value
              && document.getElementsByClassName('data_approved')[0].checked
          ) {
            document.getElementById('program-psychological-finish').classList.add('actived');
          }
        });

        // '결과보기' 버튼 선택 시
        document.getElementById('program-psychological-finish').addEventListener('click', () => {
          if (document.getElementById('program-psychological-finish').classList.contains('actived')) {
            name = document.getElementsByClassName('name')[0].value;
            email = document.getElementsByClassName('email')[0].value;
            phoneNumber = document.getElementsByClassName('phoneNumber')[0].value;

            if (name && email && phoneNumber) {
              userData = {
                name, email, phoneNumber,
              };

              const reqData = {
                type: 'submit',
                clientID: getClientID(),
                testType: 'total_care',
                testResult: {
                  user: userData,
                  report: testOverAllResult,
                  answers: testAllAnswers,
                },
              };

              requestPOST(`${OLD_API_URL}/test/`, reqData, (status, resData) => {
                if (!resData.result) {
                  alert(resData.message);
                  return false;
                }

                const testListArr = Object.keys(preAnswerPoint);

                localStorage.removeItem('testOngoing');
                localStorage.removeItem('testList');
                localStorage.removeItem('totalQuestionCount');
                localStorage.removeItem('clickedAnswerData');

                for (let i = 0; i < testListArr.length; i += 1) {
                  localStorage.removeItem(testListArr[i]);
                }

                window.location.href = `/service/test/total-care/report/?id=${resData.data.shareID}`;
              });
            }
          }
        });
      }
    } else {
      const psycologicalQuestionList = document.getElementsByClassName('program-psychological-answer-table');

      for (let i = 0; i < psycologicalQuestionList.length; i += 1) {
        if (!psycologicalQuestionList[i].getElementsByClassName('clicked')[0]) {
          const unchecked = programQuestionsList.getElementsByTagName('h4')[i].offsetTop;
          window.scroll({ top: unchecked - 134, left: 0, behavior: 'smooth' });
          if (clickedArrayStep2[i] !== 1) {
            programQuestionsList.getElementsByTagName('h4')[i].classList.add('is-orange');
            break;
          }
        }
      }
    }
  });

  // '이전' 버튼 선택 시
  document.getElementsByClassName('program-prev-start')[0].addEventListener('click', () => {
    const targetTestChecked = [];
    const hasTarget = sortTestList.indexOf(targetTest);

    for (let i = 0; i < programQuestionsList.getElementsByTagName('table').length; i += 1) {
      const clickedNode = programQuestionsList.getElementsByTagName('table')[i].getElementsByClassName('clicked')[0];
      if (programQuestionsList.getElementsByTagName('table')[i].getElementsByClassName('clicked')[0]) {
        targetTestChecked.push(clickedNode.dataset.value);
      } else {
        targetTestChecked.push(-1);
      }
    }

    localStorage.setItem(targetTest, JSON.stringify(targetTestChecked));

    // Object.keys(sortTestList)
    if (hasTarget !== -1 && sortTestList[hasTarget - 1]) {
      setProgramQuestionsEl(sortTestList[hasTarget - 1]);
    }
  });

  if (targetTest === sortTestList[0]) {
    document.getElementsByClassName('program-prev-start')[0].style.display = 'none';
  }
};

document.addEventListener('DOMContentLoaded', () => {
  if (
    window.location.hash
      && window.location.hash.indexOf('process=')
      && window.location.hash.split('#process=')[1]
  ) {
    if (window.location.hash.split('#process=')[1] == 1) {
      document.getElementById('program-intro').style.display = 'block';
    } else if (window.location.hash.split('#process=')[1] == 2) {
      document.getElementsByClassName('page-program-type-questions')[0].style.display = 'block';
      document.getElementById('program-type-questions').style.display = 'block';
    } else if (window.location.hash.split('#process=')[1] == 3) {
      document.getElementById('program-type-select').style.display = 'block';
    } else if (window.location.hash.split('#process=')[1] == 4) {
      document.getElementsByClassName('page-program-questions')[0].style.display = 'block';
      document.getElementById('program-questions').style.display = 'block';
    } else if (window.location.hash.split('#process=')[1] == 5) {
      document.getElementsByClassName('page-program-questions-more')[0].style.display = 'block';
      document.getElementById('program-questions-more').style.display = 'block';
    }
  }

  // 나의 심리상태 평가시작
  if (document.getElementById('pre-program-psychological-start')) {
    document.getElementById('pre-program-psychological-start').addEventListener('click', () => {
      window.location.href = '/service/test/total-care/program/';
    });
  } else {
    document.getElementsByClassName('page-program-type-questions')[0].style.display = 'block';
    document.getElementById('program-type-questions').style.display = 'block';
    setControlPage();
    initProgressBar(0, 0);

    // 나의 심리상태 평가하기
    const preQuestionEl = document.getElementsByClassName('pre-program-psychological-answer-table');
    const preQuestionLength = document.getElementsByClassName('pre-program-psychological-answer-table').length;

    const clickedArrayStep1 = [];
    clickedArrayStep1.length = preQuestionLength;

    for (let i = 0; i < preQuestionLength; i += 1) {
      const preQuestionAnswerEl = preQuestionEl[i].getElementsByTagName('td');
      const preQuestionAnswerLength = preQuestionEl[i].getElementsByTagName('td').length;

      for (let j = 0; j < preQuestionAnswerLength; j += 1) {
        preQuestionAnswerEl[j].addEventListener('click', () => {
          for (let k = 0; k < preQuestionAnswerLength; k += 1) {
            preQuestionAnswerEl[k].classList.remove('clicked');
          }

          if (!preQuestionAnswerEl[j].classList.contains('clicked')) {
            clickedArrayStep1[i] = 1;
            preQuestionAnswerEl[j].classList.add('clicked');
            document.getElementsByTagName('h4')[i].classList.remove('is-orange');
            preAnswerPoint[preQuestionEl[i].classList[1]] = preQuestionAnswerEl[j].innerHTML * 1;
          }

          initProgressBar(document.getElementsByClassName('program-type-questions-point')[0].getElementsByClassName('clicked').length, 5);

          if (document.getElementsByClassName('program-type-questions-point')[0].getElementsByClassName('clicked').length === 5) {
            document.getElementById('program-psychological-start').classList.add('actived');
          }
        });
      }
    }

    // 나의 심리상태 진단하기
    document.getElementById('program-psychological-start').addEventListener('click', () => {
      // for (let i = 0; i < preQuestionLength; i++) {
      //   const preQuestionAnswerEl = preQuestionEl[i].getElementsByTagName('td');
      //   const preQuestionAnswerLength = preQuestionEl[i].getElementsByTagName('td').length;
      //
      //   for (let j = 0; j < preQuestionAnswerLength; j++) {
      //     if (preQuestionAnswerEl[j].classList.contains('clicked')) {
      //       clickedPreProgramCount += 1;
      //     }
      //   }
      // }

      document.getElementsByClassName('page-program-type-questions')[0].style.display = 'none';
      document.getElementById('program-type-questions').style.display = 'none';

      document.getElementById('program-type-select').style.display = 'block';
      setControlPage();

      // preQuestionPointSorted = Object.keys(preAnswerPoint).sort((a, b) => preAnswerPoint[b] - preAnswerPoint[a]);

      // '맞춤 항목 검사' 시작
      // document.getElementById('program-psychological-start-specific').addEventListener('click', () => {
      //   preQuestionPointSorted = preQuestionPointSorted.splice(0, 4);
      //   sortTestList = preQuestionPointSorted;
      //
      //   document.getElementById('program-type-select').style.display = 'none';
      //
      //   document.getElementsByClassName('page-program-questions')[0].style.display = 'block';
      //   document.getElementById('program-questions').style.display = 'block';
      //
      //   initProgressBar(0, 0);
      //   return setProgramQuestionsEl(sortTestList[0]);
      // });

      // '종합 검사' 시작
      document.getElementById('program-psychological-start-all').addEventListener('click', () => {
        sortTestList = preQuestionPointSorted;

        document.getElementById('program-type-select').style.display = 'none';

        document.getElementsByClassName('page-program-questions')[0].style.display = 'block';
        document.getElementById('program-questions').style.display = 'block';

        initProgressBar(0, 0);
        return setProgramQuestionsEl(sortTestList[0]);
      });

      // FIXME :: EAP 검사 전용
      document.getElementById('program-psychological-start-all').click();

      if (localStorage.testOngoing && localStorage.testList) {
        sortTestList = JSON.parse(localStorage.testList);
        totalQuestionCount = localStorage.totalQuestionCount * 1;
        clickedAnswerData = (localStorage.clickedAnswerData * 1);

        document.getElementsByClassName('page-program-type-questions')[0].style.display = 'none';
        document.getElementById('program-type-questions').style.display = 'none';
        document.getElementById('program-type-select').style.display = 'none';
        document.getElementsByClassName('page-program-questions')[0].style.display = 'block';
        document.getElementById('program-questions').style.display = 'block';

        setControlPage();
        setProgramQuestionsEl(localStorage.testOngoing);
        initProgressBar(clickedAnswerData, totalQuestionCount);
      }
    });
  }
});

// if (window.location.href.indexOf('/service/test/psychological/program') !== -1) {
//   window.addEventListener('beforeunload', () => {
//     const programQuestionsList = document.getElementById('program-questions-list');
//     const targetTestChecked = [];
//     totalQuestionCount = 0;
//
//     for (let i = 0; i < programQuestionsList.getElementsByTagName('table').length; i += 1) {
//       const clickedNode = programQuestionsList.getElementsByTagName('table')[i].getElementsByClassName('clicked')[0];
//       if (programQuestionsList.getElementsByTagName('table')[i].getElementsByClassName('clicked')[0]) {
//         targetTestChecked.push(clickedNode.dataset.value * 1);
//       } else {
//         targetTestChecked.push(-1);
//       }
//     }
//
//     for (let i = 0; i < sortTestList.length; i += 1) {
//       totalQuestionCount += realQuestions[sortTestList[i]].length;
//     }
//
//     if (targetData) localStorage.setItem('testOngoing', targetData);
//     if (targetTestChecked.length) localStorage.setItem(targetData, JSON.stringify(targetTestChecked));
//     if (sortTestList.length) localStorage.setItem('testList', JSON.stringify(sortTestList));
//     if (totalQuestionCount) localStorage.setItem('totalQuestionCount', totalQuestionCount);
//     localStorage.setItem('clickedAnswerData', clickedAnswerData);
//   });
// } else {
window.addEventListener('beforeunload', () => {
  const preAnswerPoint = {
    depression: 0,
    anxiety: 0,
    // trauma: 0,
    negative: 0,
    selfesteem: 0,
    relationship: 0,
    groupStress: 0,
  };
  const testListArr = Object.keys(preAnswerPoint);

  localStorage.removeItem('testOngoing');
  localStorage.removeItem('testList');
  localStorage.removeItem('totalQuestionCount');
  localStorage.removeItem('clickedAnswerData');

  for (let i = 0; i < testListArr.length; i += 1) {
    localStorage.removeItem(testListArr[i]);
  }
});
// }

const onScrollEvent = () => {
  const scrollHeight = deviceOS === 'web' ? 373 : 244;
  if (window.scrollY < scrollHeight) {
    if (bgTop1) {
      bgTop1.style.marginBottom = '0';
      fixedProgressBarStep1.classList.remove('is-fix-tab');
    }

    if (bgTop2) {
      bgTop2.style.marginBottom = '0';
      fixedProgressBarStep2.classList.remove('is-fix-tab');
    }
  } else {
    if (bgTop1) {
      bgTop1.style.marginBottom = '64px';
      fixedProgressBarStep1.classList.add('is-fix-tab');
    }

    if (bgTop2) {
      bgTop2.style.marginBottom = '64px';
      fixedProgressBarStep2.classList.add('is-fix-tab');
    }
  }
};

window.addEventListener('scroll', onScrollEvent);

for (let i = 0; i < questionScoreStep1.length; i += 1) {
  questionScoreStep1[i].addEventListener('click', () => {
    if (!questionScoreStep1[i + 1]) {
      const lastScorll = 300;
      window.scrollBy({ top: lastScorll, left: 0, behavior: 'smooth' });
      return false;
    }

    if (i === 0) {
      const elementPosition = document.getElementById('program-type-questions').getBoundingClientRect().top - 80;

      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth',
      });

      return false;
    }

    const moveScrollTop = questionScoreStep1[i + 1].getBoundingClientRect().y - questionScoreStep1[i].getBoundingClientRect().y;
    window.scrollBy({ top: moveScrollTop, left: 0, behavior: 'smooth' });
  });
}
